module.exports = __webpack_public_path__ + "placeholder.ea7ed264.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/token_earning/placeholder.png
// module id = 2529
// module chunks = 0